import * as React from 'react';
export const googleSvg = React.forwardRef(function googleSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.765 13.823h-11.53v4.628h6.611a5.444 5.444 0 0 1-.84 2.068 5.551 5.551 0 0 1-1.607 1.572v3.011h3.934a11.74 11.74 0 0 0 2.788-4.044c.944-2.285 1.055-4.815.644-7.235Z',
      fill: '#4285F4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.235 28c3.295 0 6.085-1.055 8.098-2.898l-3.934-3.01a7.42 7.42 0 0 1-4.164 1.145 7.409 7.409 0 0 1-4.238-1.39 7.198 7.198 0 0 1-2.625-3.553H5.3v3.078a12.104 12.104 0 0 0 4.511 4.837A12.405 12.405 0 0 0 16.235 28Z',
      fill: '#34A853',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.372 18.294a7.069 7.069 0 0 1 0-4.606v-3.1H5.3A11.847 11.847 0 0 0 4 15.98c0 1.872.445 3.719 1.3 5.392l4.072-3.078Z',
      fill: '#FBBC04',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.235 8.745a6.7 6.7 0 0 1 4.69 1.797l3.5-3.438a12.304 12.304 0 0 0-4.874-2.65 12.454 12.454 0 0 0-5.565-.252 12.352 12.352 0 0 0-5.102 2.195 12.077 12.077 0 0 0-3.584 4.19l4.072 3.1a7.198 7.198 0 0 1 2.625-3.551 7.409 7.409 0 0 1 4.238-1.391Z',
      fill: '#EA4335',
    }),
  );
});
googleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var google = {
  category: 'brand',
  colorable: false,
  name: 'google',
  svg: googleSvg,
};
